import { ReactNode } from "react";

import { Code } from "@phosphor-icons/react";
import { Label, Switch } from "@reactive-resume/ui";
import Prism from "prismjs";
import CodeEditor from "react-simple-code-editor";

import { useCoverLetterStore } from "@/client/stores/cover-letter";
import { CLCollapsibleSection } from "../../../CollapsibleSection";

export const CLCssSection = () => {
  const setValue = useCoverLetterStore((state) => state.setValue);
  const css = useCoverLetterStore((state) => state.coverLetter.data.metadata.css);

  const headerHTML: ReactNode = (
    <div className="flex items-center gap-x-4">
      <Code size={18} />
      <h2 className="line-clamp-1 text-base font-bold text-gray-800 lg:text-lg">CSS</h2>
    </div>
  );

  const contentHTML: ReactNode = (
    <main className="space-y-4">
      <div className="flex items-center gap-x-4">
        <Switch
          checked={css.visible}
          onCheckedChange={(checked) => setValue("metadata.css.visible", checked)}
        />
        <Label>Apply Custom CSS</Label>
      </div>

      <div className="rounded border p-4">
        <CodeEditor
          tabSize={4}
          value={css.value}
          className="language-css font-mono"
          highlight={(code) => Prism.highlight(code, Prism.languages.css, "css")}
          onValueChange={(value) => setValue("metadata.css.value", value)}
        />
      </div>
    </main>
  );

  return <CLCollapsibleSection id="css" header={headerHTML} content={contentHTML} />;
};
